export interface Persone_List_Interface {

  id:number,
  fullname:String,
  tarikh_Eshtekhdam:String,
  almat_Ekhtesari:String,
  img:String,
  codemeli:number,

  username:String,
  persianDate:String,
  expert_Calibration:number,
  del:boolean,
  DeletingProccess:boolean
}

export function Empty_Persone_List_Interface(){
  return{
    id:0,
    fullname:'',
    tarikh_Eshtekhdam:'',
    almat_Ekhtesari:'',
    img:'',
    codemeli:0,
    username:'',
    persianDate:'',
    expert_Calibration:0,
    del:false,
    DeletingProccess:false
  }
}
